// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    name: 'FoldIf',
    mixins: [
        template,
    ]
})
export class FoldIf extends Vue {

    @Prop({default: false})
    public unFold!: boolean

    @Prop({default: 'default'})
    public theme!: string

    public get themeClass() {
        return `${this.$appPrefix}-fold-if--${this.theme ? this.theme : 'default'}`
    }

}